import React from 'react';
import {IUser, UserCategory, UserGender, UserGrade} from '../../hooks/apis/useUser';
import {Descriptions} from 'antd';
import moment from 'moment';

export default function UserDetail(props: {user: IUser}) {
  const {user} = props;
  return (
    <Descriptions bordered column={1} size={'small'}>
      <Descriptions.Item label="用户 ID">{user.userName}</Descriptions.Item>
      <Descriptions.Item label="姓名">{user.legalName}</Descriptions.Item>
      <Descriptions.Item label="性别">{UserGender[user.gender]}</Descriptions.Item>
      <Descriptions.Item label="出生日期">{moment(user.birthDate).format('YYYY-MM-DD')}</Descriptions.Item>
      <Descriptions.Item label="组别">{UserCategory[user.category]}</Descriptions.Item>
      <Descriptions.Item label="学校">{user.schoolName}</Descriptions.Item>
      <Descriptions.Item label="年级">{UserGrade[user.grade]}</Descriptions.Item>
      <Descriptions.Item label="班级">{user.classNo} 班</Descriptions.Item>
      <Descriptions.Item label="指导老师姓名">{user.coachName}</Descriptions.Item>
      <Descriptions.Item label="联系电话">{user.telephone}</Descriptions.Item>
      <Descriptions.Item label="备注">{user.remark}</Descriptions.Item>
    </Descriptions>
  );
}
